import { render, staticRenderFns } from "./editpwd.vue?vue&type=template&id=5ea23f82&"
import script from "./editpwd.vue?vue&type=script&lang=js&"
export * from "./editpwd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports